import type { StaffMemberPayload } from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';

export type StaffMemberUpdatedPayload = StaffMemberPayload;

export type StaffMemberUpdatedAction = {
	type: 'STAFF_MEMBER_UPDATED';
	payload: StaffMemberUpdatedPayload;
	organizationId: number;
};

export default (payload: StaffMemberUpdatedPayload, organizationId: number): StaffMemberUpdatedAction => ({
	type: 'STAFF_MEMBER_UPDATED',
	payload,
	organizationId,
});
